export default process.env.NODE_ENV === 'development' ?
    {
        serverUrl: ''
    } :
    {
        serverUrl: 'https://wpservices.jsparrow.xyz'
    }